const fieldParams = {
  pickup: {
    key: 'pickup',
    label: 'Your Pickup',
    placeholder: 'Your Pickup',
    title: (flow, step) =>
      flow === 'web'
        ? step === 5
          ? 'Where is your pickup?'
          : ''
        : step <= 1
        ? 'Hello!'
        : step === 6
        ? `Please check the ride details \nbelow before requesting your ride.`
        : '',
  },
  dropoff: {
    key: 'dropoff',
    label: 'Your Destination',
    placeholder: 'Your Destination',
    title: (flow, step) =>
      flow === 'web' && step === 5
        ? 'Where are you going?'
        : flow !== 'web' && step === 3
        ? 'Where are you going?'
        : '',
  },
  fare: {
    key: 'fare',
    btnText: 'Enter Payment',
    popupText: isExpired =>
      !isExpired
        ? `Your Upfront Fare includes all estimated tolls and government-mandated taxes/surcharges (which may be adjusted based on actual route taken). Any tip you select is applied at the end of the ride and is not included in the Upfront Fare.`
        : `<span>Fare Update</span> \nThe current fare has expired. \nPress OK to request an updated fare.`,
  },
  estimationError: {
    key: 'estimationError',
  },
  phone: {
    key: 'phone',
    label: 'Phone Number',
    placeholder: 'Phone Number',
    type: 'tel',
    inputMode: 'tel',
    autocomplete: 'tel',
    required: true,
    title: flow => (flow === 'web' ? `Welcome, let's ride!` : 'Let’s start by getting your number'),
    titleSub: flow =>
      flow === 'web' ? `Please enter your phone number \nto get started!` : 'We’ll send you a validation code.',
    helper: flow =>
      flow === 'web'
        ? ''
        : {
            text: 'Why do we need this?',
            above: true,
          },
    noteText: flow => (flow === 'web' ? '' : 'Note: Your driver will not see your real number.'),
    popupText: `Curb needs your phone number so that you get text alerts when your ride is assigned and arrives, and so that your driver can contact you (anonymously) if needed when picking you up. We’ll also text you your receipt at the end of the ride.`,
    errorMessage: 'Please enter a valid phone number',
  },
  code: {
    key: 'code',
    type: 'number',
    inputMode: 'numeric',
    required: true,
    length: 6,
    title: 'What’s the code?',
    titleSub: 'Enter the code sent to',
    btnText: 'Confirm',
    helper: {
      text: 'Resend code',
    },
    popupText: isMaxNumberRequests =>
      !isMaxNumberRequests
        ? 'A new code was resent to your phone.'
        : `Sorry, phone verification has failed. \nPlease try entering your phone number again.`,
    errorMessage: 'Please enter a valid code',
  },
  name: {
    key: 'name',
    label: 'Name & Last Name',
    placeholder: 'Name & Last Name',
    autocomplete: 'name',
    required: true,
    preTitle: flow => (flow === 'web' ? 'Let’s get your account created.' : ''),
    title: flow =>
      flow === 'signUp' ? 'We only need a few more items to create your Curb account.' : 'What’s your name?',
    titleSub: flow =>
      flow === 'signUp'
        ? 'Your ride receipt will be sent to your login email after your ride ends.'
        : 'Your name will help your driver confirm it’s you!',
  },
  email: {
    key: 'email',
    label: flow => (flow === 'signUp' ? 'Login Email' : 'Email'),
    placeholder: flow => (flow === 'signUp' ? 'Login Email' : 'Email'),
    type: 'email',
    inputMode: 'email',
    autocomplete: 'email',
    required: true,
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    title: flow => {
      let t = '';
      switch (flow) {
        case 'quest':
          t = 'Your ride receipt will be emailed to you after your ride ends.';
          break;
        case 'signUp':
          t = '';
          break;
        default:
          t = 'What’s your email?';
          break;
      }
      return t;
    },
    titleSub: flow =>
      flow === 'web' ? 'We’ll need this to send you your receipts and other information about riding with Curb.' : '',
    errorMessage: 'Please enter a valid email',
  },
  eReceipt: {
    key: 'email',
    label: 'Email',
    placeholder: 'Email',
    type: 'email',
    inputMode: 'email',
    autocomplete: 'email',
    required: false,
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    titleSub: 'Enter your email address to get a copy of your receipt',
    btnText: '',
    popupTitle: 'Receipt sent',
    popupText: 'Email sent successfully',
    errorMessage: 'Please enter a valid email',
  },
  password: {
    key: 'password',
    label: 'Password',
    placeholder: 'Password',
    type: 'password',
    autocomplete: 'password',
    required: true,
    pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[$%&#*?!@^]).{8,}$/i,
    title: flow => (flow === 'web' ? 'Please enter your password' : ''),
    errorMessage:
      'Password must\n' +
      'Be minimum of 8 characters.\n' +
      'NOT contain any white spaces.\n' +
      'Contain at least one: \n' +
      ' - symbol: $, %, &, #, *, ?, !, @, ^\n' +
      ' - upper case \n' +
      ' - lowercase\n' +
      ' - number\n',
  },
  rePassword: {
    key: 'rePassword',
    label: 'Re-enter Password',
    placeholder: 'Re-enter Password',
    type: 'password',
    required: true,
    pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[$%&#*?!@^]).{8,}$/i,
    errorMessage: `Passwords don't match`,
  },
  privacyTerms: {
    key: 'privacyTerms',
    urlList: {
      privacy: 'https://gocurb.com/privacy',
      terms: 'https://gocurb.com/terms/',
    },
  },
  eReceiptError: {
    popupTitle: 'Sorry there was a problem',
    popupText: 'Email not sent',
  },
  payment: {
    key: 'payment',
    label: 'Payment Method',
    placeholder: 'Payment',
    type: 'payment',
    inputMode: 'payment',
    btnText: 'Next',
  },
  accessibleVehicle: {
    key: 'accessibleVehicle',
    label: 'Accessible Vehicle',
    icon: 'accessible-vehicle',
  },
  keepSignedIn: {
    key: 'keepSignedIn',
    label: 'Keep me signed in',
  },
  termsAndConditions: {
    key: 'termsAndConditions',
    label: flow =>
      `${
        flow === 'web' ? 'By proceeding' : 'By entering your payment method details\n and proceeding'
      }, you agree to the Curb Mobility\n <a href="https://gocurb.com/terms/" target="_blank" rel="noreferrer">TERMS</a> and <a href="https://gocurb.com/privacy/" target="_blank" rel="noreferrer">PRIVACY POLICY</a>`,
  },
  notes: {
    key: 'notes',
    label: 'Notes',
    placeholder: 'Notes',
    inputMode: 'notes',
  },
  country: {
    key: 'country',
    label: 'Country',
    placeholder: 'Country',
    inputMode: 'country',
  },
  startRide: {
    key: 'startRide',
    popupText: 'Your ride has started',
  },
  notInTaxi: {
    key: 'notInTaxi',
    popupText: 'If your ride has started but you’re not in the taxi, please cancel your ride',
  },
  upcomingRide: {
    key: 'upcomingRide',
    popupText:
      'Thanks for booking! We’ll notify you when your driver is on the way. <br/>You can review or cancel this ride on the “UPCOMING RIDE” page. <br/>You can take Now rides until 15 minutes before scheduled ride. <br/> <b>Note:</b> You cannot schedule another Upcoming ride until this one concludes.',
    popupTitle: 'Your upcoming ride',
  },
  call: {
    key: 'call',
    popupTitle: 'Call',
  },
  cancelRide: {
    key: 'cancelRide',
    popupTitle: 'Cancel Ride?',
    popupText: `Are you sure you want to cancel?\n You may be charged a fee if you decide to cancel this ride.`,
  },
  cancelConfirmationRide: {
    key: 'cancelConfirmationRide',
  },
  cancelRideSuccess: {
    key: 'cancelRideSuccess',
    popupText: 'Ride was successfully canceled.',
  },
  cancelRideError: {
    key: 'cancelRideError',
    popupText: 'Sorry, an error occurred while cancelling your ride.',
  },
  comingSoon: {
    key: 'comingSoon',
    popupText: 'The feature is coming soon',
  },
  missedRide: {
    key: 'missedRide',
    popupTitle: 'Ride Canceled!',
    popupText: 'Your ride has been canceled by the Curb system. Please book a new ride if necessary.',
  },
  signUpOfferPre: {
    key: 'signUpOfferPre',
    popupText: 'Want a ride receipt emailed? Sign Up now to make booking faster next time OR continue as a guest.',
  },
  signUpOfferPost: {
    key: 'signUpOfferPost',
    popupText: 'Sign Up now to make booking faster next time.',
  },
  signUpSuccess: {
    key: 'signUpSuccess',
    popupText:
      '<div><span>Your Curb account has been successfully created! </span><span>Now you can book a ride.</span></div>',
  },
  downloadApp: {
    key: 'downloadApp',
    title: 'Your Curb account has been created!',
    titleSub: 'Download the Curb app now for the best ride booking experience.',
    downloadUrlList: {
      iphone: 'https://goo.gl/5itlw7',
      android: 'https://goo.gl/AnH6ji',
    },
  },
  downloadAppWeb: {
    key: 'downloadAppWeb',
    downloadUrlList: {
      iphone: 'https://goo.gl/5itlw7',
      android: 'https://goo.gl/AnH6ji',
    },
  },
  requestRide: {
    key: 'requestRide',
    title: 'Select Ride Type',
  },
  driverNote: {
    key: 'driverNote',
    label: 'Driver Note',
    placeholder: 'Add Driver Note',
  },
  rideType: {
    key: 'rideType',
    label: 'rideType',
  },
  confirmBook: {
    key: 'confirmBook',
    title: 'Confirm Pickup & Book',
  },
  rideTypeInput: {
    key: 'rideTypeInput',
    label: 'Vehicle Type',
  },
  fleetsProvider: {
    key: 'fleetsProvider',
    id: 'fleets-dropdown',
  },
  logOut: {
    key: 'logOut',
    popupText: 'Are you sure you want to logout?',
  },
  userLocation: {
    key: 'userLocation',
    popupText: 'Please update your browser settings to allow access to your location.',
  },
  noPayments: {
    key: 'noPayments',
    popupText: 'Sorry, you must select a payment method',
  },
  removePayment: {
    key: 'removePayment',
    popupText: card => `Are you sure you want to delete ${card}?`,
  },
  upcomingRideInfo: {
    key: 'upcomingRideInfo',
    title: 'Your Upcoming Ride',
  },
  pickupDisplay: {
    key: 'pickupDisplay',
    label: 'Your Pickup',
    param: 'pickup',
  },
  dropoffDisplay: {
    key: 'dropoffDisplay',
    label: 'Your Destination',
    param: 'dropoff',
  },
  canceledUpcomingRideBySystem: {
    key: 'canceledUpcomingRideBySystem',
    popupTitle: 'Upcoming Ride Canceled!',
    popupText: 'Your upcoming ride has been canceled by the Curb system, since you already have a ride in progress.',
  },
  noFare: {
    key: 'noFare',
    popupText: 'Sorry, we cannot estimate your ride',
  },
  manageSmsNotificationMenu: {
    key: 'manageSmsNotificationMenu',
    popupTitle: 'About Ride Notifications',
    popupText:
      'Curb strongly encourages our riders to keep  text notifications enabled so that they receive important ride status and driver detail notifications to the app after requesting a ride.',
    btnText: ['Disable Notifications', 'Cancel'],
  },
  manageSmsNotification: {
    key: 'manageSmsNotification',
    title: 'Sign up for text notifications',
    titleSub: 'SMS Notifications',
    body: (
      <div>
        Message and data rates may apply. Message frequency can vary per requested ride. Reply HELP for help. Reply STOP
        to opt out. By enabling the toggle, you agree to Curb’s{' '}
        <a href="https://gocurb.com/terms/" target="_blank" rel="noreferrer">
          Terms Of Use
        </a>{' '}
        and{' '}
        <a href="https://gocurb.com/privacy/" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        .
      </div>
    ),
  },
};

export default fieldParams;
